var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12 mb-4 d-sm-block" }, [
    _c("div", { staticClass: "limited-width-lg" }, [
      _c("div", { staticClass: "services-list" }, [
        _c("div", { staticClass: "pr-3" }, [
          _c("h2", { staticClass: "color-teal-base text-uppercase mb-4" }, [
            _vm._v(_vm._s(_vm.translate.login.offeringServicesFeatures))
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list-unstyled mb-0" }, [
            _c("li", [
              _vm._v(_vm._s(_vm.translate.login.registerSeekingText1))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.translate.login.registerSeekingText2))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.translate.login.registerSeekingText3))
            ]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.translate.login.registerSeekingText4))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pl-3" }, [
          _c("h2", { staticClass: "color-teal-base text-uppercase mb-4" }, [
            _vm._v(_vm._s(_vm.translate.login.seekingServicesFeatures))
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list-unstyled mb-0" }, [
            _c("li", [
              _vm._v(_vm._s(_vm.translate.login.registerOfferingText1))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.translate.login.registerOfferingText2))
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.translate.login.registerOfferingText3))
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00dcdeeb", { render: render, staticRenderFns: staticRenderFns })
  }
}